



























import Component from 'vue-class-component';
import { Emit, Watch } from 'vue-property-decorator';
import { ICriterion, IDictionary, IFormControl } from '../../../../entities';
import { FormFilterComponent } from '@/components/base/form-filter/form-filter.component';

@Component({})
export default class OfficesCriteriaComponent extends FormFilterComponent {
    public formState: IDictionary<IFormControl> = {
        username: {
            key: 'username',
            label: 'Username',
            value: null,
            toCriterion: (value) => {
                return (
                    (value && {
                        field: 'username',
                        value: `%${value}%`,
                        operator: 'LIKE'
                    }) ||
                    null
                );
            }
        }
    };

    public created() {
        this.doSearch();
    }

    public defaultFormValues(): IDictionary<any> {
        return {
            username: null,
        };
    }

    public getQueryObject(formState: IDictionary<IFormControl>) {
        return this.toCriteria();
    }

    @Emit()
    public search(criteria: ICriterion[]) {
        // empty
    }

    @Watch('$route')
    private onRouteChanged(val: string, oldVal: string) {
        this.doSearch();
    }
}
